<section #cardRoot class="dynamic-table-card" [style.height]="cardHeight" [ngStyle]="tableStyle">
  <header #tableHeader class="dynamic-table-header" *ngIf="title || exportEnabled">
    <div class="dynamic-table-title" *ngIf="title">{{ title }}</div>
    <button
      *ngIf="exportEnabled"
      type="button"
      class="dynamic-table-export"
      [disabled]="loading || rows.length === 0"
      (click)="exportCsv()">
      <span class="dynamic-table-export-icon" aria-hidden="true">↓</span>
      Export CSV
    </button>
  </header>

  <div class="dynamic-table-state" *ngIf="loading">{{ loadingMessage }}</div>
  <div class="dynamic-table-state dynamic-table-state--error" *ngIf="!loading && errorMessage">{{ errorMessage }}</div>
  <div class="dynamic-table-state" *ngIf="!loading && !errorMessage && rows.length === 0">{{ emptyMessage }}</div>

  <div
    #tableScroll
    class="dynamic-table-scroll"
    *ngIf="!loading && !errorMessage && rows.length > 0"
    [style.max-height]="tableMaxHeight || null">
    <table class="dynamic-table">
      <thead [class.dynamic-table-sticky-header]="stickyHeader">
        <tr>
          <th
            *ngFor="let column of columns; trackBy: trackByColumn"
            [ngStyle]="getHeaderColumnStyle(column)">
            {{ column.header }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of rows; let rowIndex = index; trackBy: trackByRow">
          <td
            *ngFor="let column of columns; trackBy: trackByColumn"
            [ngClass]="getCellClass(column)"
            [ngStyle]="getBodyColumnStyle(column)">
            <span
              *ngIf="(column.type || 'text') === 'badge'; else defaultCell"
              class="dynamic-table-badge"
              [ngStyle]="getBadgeStyle(row, column)">
              {{ formatCellValue(row, column) }}
            </span>
            <ng-template #defaultCell>
              <span
                class="dynamic-table-cell-content"
                [class.dynamic-table-cell-content--hoverable]="hasHoverPopup(column)"
                [attr.tabindex]="hasHoverPopup(column) ? 0 : null"
                (keydown.enter)="showHoverPopup($event, row, column)"
                (keydown.space)="showHoverPopup($event, row, column)"
                (click)="showHoverPopup($event, row, column)">
                {{ formatCellValue(row, column) }}
              </span>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div
    class="dynamic-table-hover-popover"
    *ngIf="activeHoverPopup as popup"
    (click)="hideHoverPopup()">
    <section
      class="dynamic-table-hover-dialog"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="popup.title"
      (click)="$event.stopPropagation()">
      <header class="dynamic-table-hover-dialog-header">
        <div class="dynamic-table-hover-dialog-heading">
          <h3>{{ popup.title }}</h3>
          <p>{{ popup.subtitle }}</p>
        </div>
        <button
          type="button"
          class="dynamic-table-hover-close"
          aria-label="Close details"
          (click)="hideHoverPopup()">
          &times;
        </button>
      </header>

      <div class="dynamic-table-hover-table-wrap">
        <table class="dynamic-table-hover-table">
          <thead>
            <tr>
              <th *ngFor="let column of popup.columns; trackBy: trackByPopupColumn">{{ column.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="popup.loading || popup.errorMessage">
              <td [attr.colspan]="popup.columns.length || 1" class="dynamic-table-hover-state">
                {{ popup.loading ? 'Loading details...' : popup.errorMessage }}
              </td>
            </tr>
            <tr *ngFor="let row of popup.rows; trackBy: trackByPopupRow">
              <td *ngFor="let value of row.values; trackBy: trackByPopupColumn">{{ value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</section>
